import React, { useState } from "react";
import axios from "../../../utils/axiosInstance";
import { X, Plus, Trash, ChartBar } from "@phosphor-icons/react";

export const CreatePollModal = ({ channelId, channelName, onClose, onCreated }) => {
  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState(["", ""]);
  const [multiple, setMultiple] = useState(false);
  const [anonymous, setAnonymous] = useState(false);
  const [saving, setSaving] = useState(false);

  const setOpt = (i, v) => setOptions((p) => p.map((o, j) => (j === i ? v : o)));
  const filled = options.filter((o) => o.trim()).length;

  const submit = async () => {
    if (!question.trim() || filled < 2) return alert("Podaj pytanie i co najmniej 2 odpowiedzi");
    setSaving(true);
    try {
      await axios.post("/api/chat/polls", { channel_id: channelId, question, options, multiple, anonymous });
      onCreated();
    } catch (e) { alert("Błąd: " + (e.response?.data?.detail || e.message)); }
    finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-5 space-y-3 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid="poll-create-modal">
        <div className="flex items-center justify-between">
          <h3 className="text-base font-bold flex items-center gap-2"><ChartBar className="w-5 h-5 text-[#2563EB]" /> Nowa ankieta · #{channelName}</h3>
          <button onClick={onClose} className="p-1 rounded hover:bg-slate-100" data-testid="poll-create-close"><X className="w-5 h-5" /></button>
        </div>
        <input value={question} onChange={(e) => setQuestion(e.target.value)} placeholder="Pytanie" className="w-full border border-border rounded-md px-3 py-2 text-sm" data-testid="poll-question-input" />
        <div className="space-y-2">
          {options.map((o, i) => (
            <div key={i} className="flex gap-2">
              <input value={o} onChange={(e) => setOpt(i, e.target.value)} placeholder={`Odpowiedź ${i + 1}`} className="flex-1 border border-border rounded-md px-3 py-2 text-sm" data-testid={`poll-option-input-${i}`} />
              {options.length > 2 && (
                <button onClick={() => setOptions((p) => p.filter((_, j) => j !== i))} className="p-2 text-red-500 hover:bg-red-50 rounded-md" data-testid={`poll-option-remove-${i}`}><Trash className="w-4 h-4" /></button>
              )}
            </div>
          ))}
          {options.length < 12 && (
            <button onClick={() => setOptions((p) => [...p, ""])} className="inline-flex items-center gap-1 text-xs font-semibold text-[#2563EB] hover:underline" data-testid="poll-option-add">
              <Plus className="w-3.5 h-3.5" /> Dodaj odpowiedź
            </button>
          )}
        </div>
        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <input type="checkbox" checked={multiple} onChange={(e) => setMultiple(e.target.checked)} className="w-4 h-4" data-testid="poll-multiple-checkbox" />
          Wielokrotny wybór
        </label>
        <label className="flex items-start gap-2 text-sm cursor-pointer">
          <input type="checkbox" checked={anonymous} onChange={(e) => setAnonymous(e.target.checked)} className="w-4 h-4 mt-0.5" data-testid="poll-anonymous-checkbox" />
          <span>Ukryj głosy <span className="block text-xs text-muted-foreground">Pracownicy widzą tylko liczby, admin widzi kto głosował</span></span>
        </label>
        <div className="flex justify-end gap-2 pt-1">
          <button onClick={onClose} className="px-4 py-2 text-sm rounded-md bg-slate-100 hover:bg-slate-200" data-testid="poll-create-cancel">Anuluj</button>
          <button onClick={submit} disabled={saving} className="px-4 py-2 text-sm rounded-md bg-[#2563EB] text-white font-semibold disabled:opacity-50" data-testid="poll-create-submit">
            {saving ? "Tworzenie..." : "Utwórz ankietę"}
          </button>
        </div>
      </div>
    </div>
  );
};
